// Fetch list

export const FETCH = 'transportStates.FETCH'
export const FETCH_STARTED = 'transportStates.FETCH_STARTED'
export const FETCH_FULFILLED = 'transportStates.FETCH_FULFILLED'
export const FETCH_REJECTED = 'transportStates.FETCH_REJECTED'
export const FETCH_CANCELLED = 'transportStates.FETCH_CANCELLED'

export const SORTING_CHANGED = 'transportStates.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'transportStates.FETCH_ONE'
export const FETCH_ONE_STARTED = 'transportStates.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'transportStates.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'transportStates.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'transportStates.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'transportStates.SAVE'
export const SAVE_STARTED = 'transportStates.SAVE_STARTED'
export const SAVE_FULFILLED = 'transportStates.SAVE_FULFILLED'
export const SAVE_REJECTED = 'transportStates.SAVE_REJECTED'
export const SAVE_CANCELLED = 'transportStates.SAVE_CANCELLED'

// Delete

export const DELETE = 'transportStates.DELETE'
export const DELETE_STARTED = 'transportStates.DELETE_STARTED'
export const DELETE_FULFILLED = 'transportStates.DELETE_FULFILLED'
export const DELETE_REJECTED = 'transportStates.DELETE_REJECTED'
export const DELETE_CANCELLED = 'transportStates.DELETE_CANCELLED'
